const MetricValueTypes = {
    ZERO_TO_TEN: 'ZERO_TO_TEN',
    ZERO_TO_HUNDRED: 'ZERO_TO_HUNDRED',
    ZERO_TO_INFINITY: 'ZERO_TO_INFINITY',
};

export default MetricValueTypes;
